import Vue from 'vue'

import router from './router'
import store from './store'

import App from './App.vue'
import '@/styles/main.scss'

import vuetify from '@/plugins/vuetify'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
